export default "__VITE_ASSET__npAXhaky__"